<template>
    <div class="PopupBuilderWrapper">
        <div class="PopupBuilderContainer">
            <div class="DraggableSection">
                <WText
                    :size="24"
                    weight="bold"
                >
                    {{ $t('schema.popup.properties.all') }}
                </WText>
                <Draggable
                    class="DraggableItems"
                    :list="availableProperties"
                    group="popupProperties"
                >
                    <div
                        v-for="property in availableProperties"
                        :key="property.key"
                        class="DraggableItem"
                    >
                        <WText
                            :size="18"
                        >
                            {{ property.name }}
                        </WText>
                    </div>
                </Draggable>
            </div>
            <div class="DraggableSection">
                <WText
                    :size="24"
                    color="accent-blue"
                    weight="bold"
                >
                    {{ $t('schema.popup.properties.current') }}
                </WText>
                <Draggable
                    class="DraggableItems"
                    :list="popupProperties"
                    group="popupProperties"
                >
                    <div
                        v-for="property in popupProperties"
                        :key="property.key"
                        class="DraggableItem"
                    >
                        <WText
                            :size="18"
                            color="accent-blue"
                        >
                            {{ property.name }}
                        </WText>
                    </div>
                </Draggable>
            </div>
        </div>
        <div class="ButtonsContainer">
            <WButton
                outline
                color="accent-blue"
                iconLeft="refresh-ccw"
                :disabled="saveDisabled"
                @click="refreshProperties"
            >
                {{ $t('schema.popup.reset') }}
            </WButton>
            <WButton
                iconLeft="save"
                :disabled="saveDisabled"
                @click="saveProperties"
            >
                {{ $t('schema.popup.save') }}
            </WButton>
        </div>
    </div>
</template>

<script>
import Draggable from 'vuedraggable'
import VueTypes from 'vue-types'
import { isEqual } from 'lodash'
import { Api, apiRequest } from '@/api'

export default {
    name: 'PopupBuilder',
    components: { Draggable },
    props: {
        entityKey: VueTypes.string,
        properties: VueTypes.array,
        fields: VueTypes.array,
    },
    data () {
        return {
            popupProperties: [],
            availableProperties: [],
            loading: false,
        }
    },
    computed: {
        saveDisabled () {
            const equal = isEqual(this.properties, this.popupProperties.map(property => property.key))
            return this.loading || equal
        },
    },
    watch: {
        properties (newProperties) {
            this.initProperties(newProperties)
        },
    },
    mounted () {
        this.initProperties(this.properties)
    },
    methods: {
        initProperties (properties) {
            this.popupProperties = properties.map(property => ({
                key: property,
                name: this.fields.find(({ key }) => key === property)?.name,
            }))
            this.availableProperties = this.fields.filter(field => !properties.includes(field.key))
        },
        refreshProperties () {
            this.$emit('refreshProperties')
        },
        saveProperties () {
            this.loading = true
            const { entityKey } = this
            const params = { properties: this.popupProperties.map(property => property.key) }
            apiRequest(Api().entities.setPopupProperties({ entityKey, params }))
                .then(() => this.refreshProperties())
                .finally(() => { this.loading = false })
        },
    },
}
</script>

<style scoped lang="scss">
.PopupBuilderWrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    gap: 30px;
    padding: 10px;
    .PopupBuilderContainer {
        flex: 1;
        display: flex;
        flex-direction: row;
        max-width: 700px;
        margin: 0 auto;
        gap: 20px;
        width: 100%;
        .DraggableSection {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;
            .DraggableItems {
                height: 100%;
                display: flex;
                flex-direction: column;
                width: 100%;
                gap: 10px;
                max-height: 500px;
                overflow-y: auto;
                padding: 15px;
                .DraggableItem {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 10px 15px 10px 15px;
                    background-color: $gray-07;
                    border-radius: $border-radius;
                    border: 1px solid $gray-04;
                    cursor: grab;
                }
            }
        }
    }
    .ButtonsContainer {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
}
</style>
